import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, Validators} from '@angular/forms';
import {Master} from '../../../admin/models/master.interface';
import {KfRegistrationDetail} from '../../models/kf-registration-detail.interface';
import {KfRegistrationService} from '../../services/kf-registration.service';
import {Router} from '@angular/router';
import {QuantitativeDetail} from '../../models/quantitative-detail.interface';
import {AuthService} from '../../../core/services/auth.service';

@Component({
  selector: 'app-kf-registration-edit-table-recycling',
  templateUrl: './kf-registration-edit-table-recycling.component.html',
  styleUrls: ['./kf-registration-edit-table-recycling.component.scss']
})
export class KfRegistrationEditTableRecyclingComponent implements OnInit {

  simpleUser = true;
  displayedColumns: string[] = ['entry', 'ru', 'mr', 'omr', 'er', 'td', 'ld', 'loss', 'total', 'remark'];
  allTotalIs100!: boolean;

  entriesForm = this.formBuilder.group({
    entries: this.formBuilder.array([this.formBuilder.group({
      ru: [0],
      mr: [0],
      er: [0],
      td: [0],
      ld: [0],
      loss: [0],
      omr: [0],
      total: [0],
      mrDifferentValueAllowed: [false],
      ruDifferentValueAllowed: [false],
      erDifferentValueAllowed: [false],
      tdDifferentValueAllowed: [false],
      ldDifferentValueAllowed: [false],
      lossDifferentValueAllowed: [false],
      omrDifferentValueAllowed: [false],
      remark: [''],
    })])
  });

  get entriesControl(): FormArray {
    return this.entriesForm.get('entries') as FormArray;
  }

  @Input()
  kfRegistrationDetail!: KfRegistrationDetail;
  @Input()
  newKfRegistrationDetail!: KfRegistrationDetail;
  @Input()
  categories!: Master[];

  @Output()
  markAsCompletedEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  resetEmitter: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  redirectUrlEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private readonly formBuilder: FormBuilder,
              private readonly kfRegistrationService: KfRegistrationService,
              private readonly router: Router,
              private readonly authService: AuthService) {
  }

  ngOnInit(): void {
    this.simpleUser = this.authService.userHasAnyRole(['SIMPLE_USER']);
    if (this.kfRegistrationDetail?.kfRegistration && this.kfRegistrationDetail?.categories) {
      this.setEntriesFormArray(this.kfRegistrationDetail.categories.length, this.kfRegistrationDetail);
      const categories: any = [];
      this.entriesControl.controls.forEach(((entry, index) => {
        categories.push({
          ru: this.kfRegistrationDetail.categories[index]?.ru !== 0
            ? this.kfRegistrationDetail.categories[index]?.ru
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index]?.ru : null),
          mr: this.kfRegistrationDetail.categories[index]?.mr !== 0
            ? this.kfRegistrationDetail.categories[index]?.mr
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index]?.mr : null),
          er: this.kfRegistrationDetail.categories[index]?.er !== 0
            ? this.kfRegistrationDetail.categories[index]?.er
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index]?.er : null),
          td: this.kfRegistrationDetail.categories[index]?.td !== 0
            ? this.kfRegistrationDetail.categories[index]?.td
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index]?.td : null),
          ld: this.kfRegistrationDetail.categories[index]?.ld !== 0
            ? this.kfRegistrationDetail.categories[index]?.ld
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index]?.ld : null),
          loss: this.kfRegistrationDetail.categories[index]?.loss !== 0
            ? this.kfRegistrationDetail.categories[index]?.loss
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index]?.loss : null),
          omr: this.kfRegistrationDetail.categories[index]?.omr !== 0
            ? this.kfRegistrationDetail.categories[index]?.omr
            : (this.kfRegistrationDetail.kfRegistration.completionStatus ? this.kfRegistrationDetail.categories[index]?.omr : null),
          remark: this.kfRegistrationDetail.categories[index]?.remark
        });
      }));
      this.entriesControl.patchValue(categories);
    } else {
      this.setEntriesFormArray(this.categories.length, this.newKfRegistrationDetail);
    }

    this.sum();
    if (this.simpleUser) {
      this.entriesForm.disable();
    }
  }

  entriesSubmit(): void {
    if (this.kfRegistrationDetail) {
      this.kfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.kfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.redirectUrlEmitter.emit(false);
      });
    } else {
      this.newKfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.newKfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.redirectUrlEmitter.emit(false);
      });
    }
  }

  allowValidation(controlName: string, index: number): void {
    this.entriesControl.at(index).get(controlName)?.setValidators([Validators.max(100), Validators.min(0)]);
    this.entriesControl.at(index).get(controlName)?.updateValueAndValidity();
    this.entriesControl.at(index).get(controlName + 'DifferentValueAllowed')?.setValue(true);
  }

  markAsCompleted(): void {
    if (this.kfRegistrationDetail) {
      this.kfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.kfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.markAsCompletedEmitter.emit();
      });
    } else {
      this.newKfRegistrationDetail.categories = this.setEntriesValues();
      this.kfRegistrationService.saveKfRegistration(this.newKfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
        this.markAsCompletedEmitter.emit();
      });
    }
    // this.kfRegistrationService.saveKfRegistration(this.newKfRegistrationDetail, this.router.url.split('/')[4]).subscribe(() => {
    //   this.markAsCompletedEmitter.emit();
    // });
  }

  reset(): void {
    this.resetEmitter.emit();
  }

  sum(): void {
    this.entriesControl.value.forEach((value: any, index: number) => {
      let total = 0;
      if (value.ru !== null && typeof value.ru === 'number') {
        total += value.ru;
      }
      if (value.mr !== null && typeof value.mr === 'number') {
        total += value.mr;
      }
      if (value.er !== null && typeof value.er === 'number') {
        total += value.er;
      }
      if (value.td !== null && typeof value.td === 'number') {
        total += value.td;
      }
      if (value.ld !== null && typeof value.ld === 'number') {
        total += value.ld;
      }
      if (value.loss !== null && typeof value.loss === 'number') {
        total += value.loss;
      }
      if (value.omr !== null && typeof value.omr === 'number') {
        total += value.omr;
      }
      this.entriesControl.controls[index].get('total')?.setValue(total.toFixed(2));
    });

    this.allTotalIs100 = true;
    for (const control of this.entriesControl.controls) {
      if (control.get('total')?.value !== '100.00') {
        this.allTotalIs100 = false;
        break;
      }
    }
  }

  private setEntriesFormArray(elements: number, kfRegistrationDetail: KfRegistrationDetail): void {
    this.entriesControl.clear();
    for (let i = 0; i < elements; i++) {
      // comprobar que haya categorias el año pasado
      // comprobar que la categoría sea del constructor (que no se guardaron datos para poner restricciones)
      if (kfRegistrationDetail?.lastYearCategories !== undefined &&
        kfRegistrationDetail?.lastYearCategories !== null &&
        !kfRegistrationDetail?.kfRegistration?.completionStatus) {
        kfRegistrationDetail.lastYearCategories.forEach((item, index) => {
          // comprobar que la categoria de este año sea la misma que la del año pasado cogiendo las categorias asociadas del año actual
          // si coincide la categoría del año actual con la de este año, ponemos restricciones
          if (this.categories[i]?.id === item.keyFiguresCategory?.id) {
            this.entriesControl.push(
              this.formBuilder.group({
                ru: [null, !kfRegistrationDetail?.categories[i]?.ruDifferentValueAllowed ?
                  [
                    Validators.max(item.ru + (kfRegistrationDetail?.deviation / 100 * item.ru)),
                    Validators.min(item.ru - (kfRegistrationDetail?.deviation / 100 * item.ru))
                  ] : []
                ],
                mr: [null, !kfRegistrationDetail?.categories[i]?.mrDifferentValueAllowed ?
                  [
                    Validators.max(item.mr + (kfRegistrationDetail?.deviation / 100 * item.mr)),
                    Validators.min(item.mr - (kfRegistrationDetail?.deviation / 100 * item.mr))
                  ] : []
                ],
                er: [null, !kfRegistrationDetail?.categories[i]?.erDifferentValueAllowed ?
                  [
                    Validators.max(item.er + (kfRegistrationDetail?.deviation / 100 * item.er)),
                    Validators.min(item.er - (kfRegistrationDetail?.deviation / 100 * item.er))
                  ] : []
                ],
                td: [null, !kfRegistrationDetail?.categories[i]?.tdDifferentValueAllowed ?
                  [
                    Validators.max(item.td + (kfRegistrationDetail?.deviation / 100 * item.td)),
                    Validators.min(item.td - (kfRegistrationDetail?.deviation / 100 * item.td))
                  ] : []
                ],
                ld: [null, !kfRegistrationDetail?.categories[i]?.ldDifferentValueAllowed ?
                  [
                    Validators.max(item.ld + (kfRegistrationDetail?.deviation / 100 * item.ld)),
                    Validators.min(item.ld - (kfRegistrationDetail?.deviation / 100 * item.ld))
                  ] : []
                ],
                loss: [null, !kfRegistrationDetail?.categories[i]?.lossDifferentValueAllowed ?
                  [
                    Validators.max(item.loss + (kfRegistrationDetail?.deviation / 100 * item.loss)),
                    Validators.min(item.loss - (kfRegistrationDetail?.deviation / 100 * item.loss))
                  ] : []
                ],
                omr: [null, !kfRegistrationDetail?.categories[i]?.omrDifferentValueAllowed ?
                  [
                    Validators.max(item.omr + (kfRegistrationDetail?.deviation / 100 * item.omr)),
                    Validators.min(item.omr - (kfRegistrationDetail?.deviation / 100 * item.omr))
                  ] : []
                ],
                total: [0],
                ruDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.ruDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.ruDifferentValueAllowed
                  : false
                ],
                mrDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.mrDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.mrDifferentValueAllowed
                  : false
                ],
                erDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.erDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.erDifferentValueAllowed
                  : false
                ],
                tdDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.tdDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.tdDifferentValueAllowed
                  : false
                ],
                ldDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.ldDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.ldDifferentValueAllowed
                  : false
                ],
                lossDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.lossDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.lossDifferentValueAllowed
                  : false
                ],
                omrDifferentValueAllowed: [kfRegistrationDetail?.categories[i]?.omrDifferentValueAllowed
                  ? kfRegistrationDetail.categories[i]?.omrDifferentValueAllowed
                  : false
                ],
                remark: [''],
              })
            );
          } else {
            if (this.categories[i]?.id) {
              this.entriesControl.push(
                this.formBuilder.group({
                  ru: [null, [Validators.max(100), Validators.min(0)]],
                  mr: [null, [Validators.max(100), Validators.min(0)]],
                  er: [null, [Validators.max(100), Validators.min(0)]],
                  td: [null, [Validators.max(100), Validators.min(0)]],
                  ld: [null, [Validators.max(100), Validators.min(0)]],
                  loss: [null, [Validators.max(100), Validators.min(0)]],
                  omr: [null, [Validators.max(100), Validators.min(0)]],
                  total: [0],
                  mrDifferentValueAllowed: [false],
                  ruDifferentValueAllowed: [false],
                  erDifferentValueAllowed: [false],
                  tdDifferentValueAllowed: [false],
                  ldDifferentValueAllowed: [false],
                  lossDifferentValueAllowed: [false],
                  omrDifferentValueAllowed: [false],
                  remark: [''],
                })
              );
            }
          }
          if (kfRegistrationDetail.lastYearCategories?.length &&
            kfRegistrationDetail.lastYearCategories?.length > 1 &&
            kfRegistrationDetail.lastYearCategories.length - 1 > index) {
            i++;
          }
        });
      } else {
        this.entriesControl.push(
          this.formBuilder.group({
            ru: [null, [Validators.max(100), Validators.min(0)]],
            mr: [null, [Validators.max(100), Validators.min(0)]],
            er: [null, [Validators.max(100), Validators.min(0)]],
            td: [null, [Validators.max(100), Validators.min(0)]],
            ld: [null, [Validators.max(100), Validators.min(0)]],
            loss: [null, [Validators.max(100), Validators.min(0)]],
            omr: [null, [Validators.max(100), Validators.min(0)]],
            total: [0],
            mrDifferentValueAllowed: [false],
            ruDifferentValueAllowed: [false],
            erDifferentValueAllowed: [false],
            tdDifferentValueAllowed: [false],
            ldDifferentValueAllowed: [false],
            lossDifferentValueAllowed: [false],
            omrDifferentValueAllowed: [false],
            remark: [''],
          })
        );
      }
    }
  }

  private setEntriesValues(): QuantitativeDetail[] {
    const quantitativeDetail: QuantitativeDetail[] = [];
    this.entriesControl.value.forEach(
      (entry: {
         mr: 0, ru: 0, er: 0, td: 0, ld: 0, loss: 0, omr: 0, mrDifferentValueAllowed: false, ruDifferentValueAllowed: false,
         erDifferentValueAllowed: false, tdDifferentValueAllowed: false, ldDifferentValueAllowed: false,
         lossDifferentValueAllowed: false, omrDifferentValueAllowed: false, remark: ''
       },
       index: number) => {
        const qd: QuantitativeDetail = {
          piecesValue: 0, tonsValue: 0, clearingHouse: 0, collection: 0, communication: 0, rd: 0, logistics: 0, office: 0, other: 0,
          treatment: 0, operationsRemark: '', overheadRemark: '',
          id: this.kfRegistrationDetail?.categories[index]?.id,
          keyFiguresCategory: this.categories[index],
          ru: entry.ru === null ? 0 : entry.ru,
          mr: entry.mr === null ? 0 : entry.mr,
          er: entry.er === null ? 0 : entry.er,
          td: entry.td === null ? 0 : entry.td,
          ld: entry.ld === null ? 0 : entry.ld,
          loss: entry.loss === null ? 0 : entry.loss,
          omr: entry.omr === null ? 0 : entry.omr,
          mrDifferentValueAllowed: entry.mrDifferentValueAllowed,
          ruDifferentValueAllowed: entry.ruDifferentValueAllowed,
          erDifferentValueAllowed: entry.erDifferentValueAllowed,
          tdDifferentValueAllowed: entry.tdDifferentValueAllowed,
          ldDifferentValueAllowed: entry.ldDifferentValueAllowed,
          lossDifferentValueAllowed: entry.lossDifferentValueAllowed,
          omrDifferentValueAllowed: entry.omrDifferentValueAllowed,
          remark: entry.remark,
          kind: 3,

          piecesDifferentValueAllowed: false,
          tonsDifferentValueAllowed: false,
          collectionDifferentValueAllowed: false,
          logisticsDifferentValueAllowed: false,
          treatmentDifferentValueAllowed: false,
          clearingHouseDifferentValueAllowed: false,
          communicationDifferentValueAllowed: false,
          rdDifferentValueAllowed: false,
          officeDifferentValueAllowed: false,
          otherDifferentValueAllowed: false,
        };
        quantitativeDetail.push(qd);
      });
    return quantitativeDetail;
  }
}
